<button
  [class.active]="active()"
  [class.open]="isOpen()"
  [class.disabled]="!path()"
  [disabled]="!path()"
  [title]="!isOpen() ? (labelKey() | translate) : ''"
  [attr.aria-current]="active() ? 'page' : null"
  (click)="navClicked.emit(path())"
  class="sidebar-btn"
>
  <i [class]="'pi ' + icon()"></i>
  @if (isOpen()) {
  <span class="sidebar-btn-label">{{ labelKey() | translate }}</span>
  }
</button>
